import { render, staticRenderFns } from "./ManufacturerPie.vue?vue&type=template&id=3a72d323&scoped=true&"
import script from "./ManufacturerPie.vue?vue&type=script&lang=js&"
export * from "./ManufacturerPie.vue?vue&type=script&lang=js&"
import style0 from "./ManufacturerPie.vue?vue&type=style&index=0&id=3a72d323&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a72d323",
  null
  
)

export default component.exports